import React from 'react';

// Fixed construction — eye borders, eyes, face seams (no drawer menu item)
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.
// Split into BaseTop / BaseMain because §4 chin and §6 ears render between them.

export function BaseTop({ parts }) {
  return (
    <>
<path className="fil-eye-border" d={parts['eye-border-path-3'] || ''}/>
    </>
  );
}

export function BaseMain({ parts }) {
  return (
    <>
<path className="fil-eye-border" d={parts['eye-border-path-9'] || ''}/>
<path className="clear" d={parts['clear-path-10'] || ''}/>
<path className="fil-eye" d={parts['eye-path-11'] || ''}/>
<path className="fil-eye" d={parts['eye-path-12'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-13'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-14'] || ''}/>
<path className="clear str_222222_20_40_20" d={parts['clear-path-15'] || ''}/>
<path className="clear str_222222_20_40_20" d={parts['clear-path-16'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-17'] || ''}/>
<path className="clear str_222222_25" d={parts['clear-path-18'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-19'] || ''}/>
<path className="clear str_222222_25" d={parts['clear-path-20'] || ''}/>
<path className="clear str_222222_75" d={parts['clear-path-21'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-22'] || ''}/>
<path className="clear str_222222_25_125_75" d={parts['clear-path-23'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-24'] || ''}/>
<path className="clear str_222222_75" d={parts['clear-path-25'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-26'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-27'] || ''}/>
<path className="clear str_222222_30" d={parts['clear-path-28'] || ''}/>
<path className="clear str_222222_20_100_60" d={parts['clear-path-29'] || ''}/>
<path className="clear str_222222_20_100_60" d={parts['clear-path-30'] || ''}/>
<path className="clear str_222222_20_100_60" d={parts['clear-path-31'] || ''}/>
<path className="clear str_222222_75" d={parts['clear-path-32'] || ''}/>
<path className="clear str_222222_30" d={parts['clear-path-33'] || ''}/>
<path className="clear str_222222_25_125_75" d={parts['clear-path-34'] || ''}/>
<path className="clear str_222222_25_125_75" d={parts['clear-path-35'] || ''}/>
    </>
  );
}
